import { render, staticRenderFns } from "./CustomerGrowerServerTable.vue?vue&type=template&id=101bf9b1"
import script from "./CustomerGrowerServerTable.vue?vue&type=script&lang=js"
export * from "./CustomerGrowerServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports